import { TriggerKeySchema } from "@redotech/redo-model/shopper-agent/trigger-definition";
import * as z from "zod";

export const selectSandboxCustomer = {
  name: "selectSandboxCustomer" as const,
  input: z.object({ triggerKey: TriggerKeySchema }).strict(),
  output: z.discriminatedUnion("status", [
    z.object({
      status: z.literal("selected"),
      customer: z.object({ id: z.string(), name: z.string().nullable() }),
      reasoning: z.string(),
    }),
    z.object({ status: z.literal("no_customer") }),
  ]),
};
